<template>
    <div class="typedocument">
        <PageTitle icon="fa fa-clone" main="Registro" sub="Tipo de Documento" />
        <b-form
            v-show="mode === 'save' || mode === 'remove' || mode === 'read'"
        >
            <input
                id="typedocument-id"
                type="hidden"
                v-model="typedocument.id"
            />
            <b-row>
                <b-col md="5" sm="12">
                    <b-form-group
                        label="Nome:"
                        label-for="typedocument-name_type_document"
                    >
                        <b-form-input
                            id="typedocument-name_type_document"
                            type="text"
                            ref="searchFocus"
                            v-model="typedocument.name_type_document"
                            required
                            size="sm"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            placeholder="Nome..."
                        />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Nome Reduzido:"
                        label-for="typedocument-name_reduced"
                    >
                        <b-form-input
                            id="typedocument-name_reduced"
                            type="text"
                            v-model="typedocument.name_reduced"
                            size="sm"
                            :readonly="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            placeholder="Reduzido..."
                        />
                    </b-form-group>
                </b-col>
                <b-col md="5" sm="12">
                    <b-form-group
                        label="Modelo Fiscal:"
                        label-for="typedocument-tax_document_id"
                    >
                        <b-form-select
                            id="typedocument-tax_document_id"
                            :disabled="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                            size="sm"
                            :options="taxdocuments"
                            v-model="typedocument.tax_document_id"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                v-model="typedocument.payment"
                                true-value="1"
                                false-value="0"
                                type="checkbox"
                                id="typedocument-payment"
                                :disabled="
                                    mode === 'remove' ||
                                        mode === 'read' ||
                                        mode === 'insert'
                                "
                            />
                            <label
                                class="form-check-label"
                                for="typedocument-payment"
                            >
                                Despesa?
                            </label>
                        </div>
                    </div>
                </b-col>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                v-model="typedocument.receipt"
                                true-value="1"
                                false-value="0"
                                type="checkbox"
                                id="typedocument-receipt"
                                :disabled="
                                    mode === 'remove' ||
                                        mode === 'read' ||
                                        mode === 'insert'
                                "
                            />
                            <label
                                class="form-check-label"
                                for="typedocument-receipt"
                            >
                                Receita?
                            </label>
                        </div>
                    </div>
                </b-col>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                v-model="typedocument.restrict_repetition"
                                true-value="1"
                                false-value="0"
                                type="checkbox"
                                id="typedocument-restrict_repetition"
                                :disabled="
                                    mode === 'remove' ||
                                        mode === 'read' ||
                                        mode === 'insert'
                                "
                            />
                            <label
                                class="form-check-label"
                                for="typedocument-restrict_repetition"
                            >
                                Não Pemitir repetição?
                            </label>
                        </div>
                    </div>
                </b-col>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input
                                class="form-check-input"
                                v-model="typedocument.generation_guide"
                                true-value="1"
                                false-value="0"
                                type="checkbox"
                                id="typedocument-generation_guide"
                                :disabled="
                                    mode === 'remove' ||
                                        mode === 'read' ||
                                        mode === 'insert'
                                "
                            />
                            <label
                                class="form-check-label"
                                for="typedocument-generation_guide"
                            >
                                Gera Guia de Recolhimento?
                            </label>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row> </b-row>
            <b-col md="3" sm="12">
                <div class="form-group">
                    <div class="form-check">
                        <input
                            class="form-check-input"
                            v-model="typedocument.blocked"
                            true-value="1"
                            false-value="0"
                            type="checkbox"
                            id="typedocument-blocked"
                            :disabled="
                                mode === 'remove' ||
                                    mode === 'read' ||
                                    mode === 'insert'
                            "
                        />
                        <label
                            class="form-check-label"
                            for="typedocument-blocked"
                        >
                            Bloqueado?
                        </label>
                    </div>
                </div>
            </b-col>
        </b-form>

        <hr v-show="mode === 'save'" />
        <b-row>
            <b-col xs="12">
                <b-button
                    size="sm"
                    variant="dark"
                    class="mt-2  mb-2 fa fa-plus"
                    v-show="mode !== 'save' && mode !== 'remove'"
                    @click="alterModo"
                >
                </b-button>
                <b-button
                    size="sm"
                    variant="dark"
                    class="mt-2 mb-2 ml-2 fa fa-save"
                    v-if="mode === 'save'"
                    @click="save"
                >
                </b-button>
                <b-button
                    size="sm"
                    variant="dark"
                    class="mt-2 mb-2 ml-2 fa fa-trash"
                    v-if="mode === 'remove'"
                    @click="remove"
                >
                </b-button>
                <b-button
                    size="sm"
                    btn-sm
                    variant="dark"
                    class="mt-2 mb-2 ml-2 fa fa-reply"
                    v-if="
                        mode === 'remove' || mode === 'save' || mode === 'read'
                    "
                    @click="reset"
                >
                </b-button>
                <b-button
                    size="sm"
                    class="mt-2 mb-2 ml-2 fa"
                    :class="icon"
                    @click="
                        ;[
                            loadTypeDocuments(),
                            toggleBusy(),
                            (showTable = !showTable),
                        ]
                    "
                    variant="dark"
                >
                </b-button>
            </b-col>
        </b-row>
        <br />
        <div class="col-sm-4">
            <div class="form-group">
                <input
                    type="text"
                    size="sm"
                    icon="search"
                    v-model="search"
                    ref="searchFocus"
                    v-show="mode !== 'save' && mode !== 'remove'"
                    placeholder="Informe a descrição"
                    class="form-control"
                />
            </div>
        </div>
        <b-row>
            <b-col md="6" sm="12">
                <transition name="slide" type="animation" appear>
                    <b-table
                        :busy="isBusy"
                        class="table-responsive"
                        v-show="showTable"
                        hover
                        key="slide"
                        head-variant="light"
                        :per-page="perPage"
                        :current-page="currentPage"
                        :items="filteredList"
                        :fields="fields"
                    >
                        <template v-slot:table-busy>
                            <div class="text-center text-info my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Carregando...</strong>
                            </div>
                        </template>
                        <template v-slot:cell(actions)="data">
                            <b-button
                                title="Detalhe do registro"
                                size="sm"
                                variant="light"
                                @click="loadTypeDocument(data.item, 'read')"
                                class="mr-2 mt-2"
                            >
                                <i class="fa fa-drivers-license-o"></i>
                            </b-button>
                            <b-button
                                title="Editar registro"
                                size="sm"
                                variant="light"
                                @click="loadTypeDocument(data.item)"
                                class="mr-2 mt-2"
                            >
                                <i class="fa fa-pencil"></i>
                            </b-button>
                            <b-button
                                title="Excluir registro"
                                size="sm"
                                variant="light"
                                @click="loadTypeDocument(data.item, 'remove')"
                                class="mr-2 mt-2"
                            >
                                <i class="fa fa-trash"></i>
                            </b-button>

                            <b-button
                                v-b-modal.modalSerie
                                title="Adicionar série"
                                size="sm"
                                variant="light"
                                @click="actionNewSerie(data.item)"
                                class="mr-2 mt-2"
                            >
                                <i class="fa fa-plus"></i>
                            </b-button>
                            <b-button
                                title="Listar série"
                                size="sm"
                                variant="light"
                                @click="actionNewSerie(data.item)"
                                class="mr-2 mt-2"
                            >
                                <i class="fa fa-tasks"></i>
                            </b-button>
                        </template>
                    </b-table>
                </transition>
                <transition name="slide" type="animation" appear>
                    <b-pagination
                        v-show="showTable"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        size="sm"
                        aria-controls="my-table"
                    ></b-pagination>
                </transition>
            </b-col>
            <b-col md="3" sm="12">
                <transition name="slide" type="animation" appear>
                    <b-table
                        class="table-responsive"
                        v-show="showTableSerie"
                        hover
                        key="slide"
                        head-variant="light"
                        :items="series"
                        :fields="fieldsSerie"
                    >
                        <template v-slot:cell(actions)="data">
                            <b-button
                                v-b-modal.modalSerie
                                title="Editar registro"
                                size="sm"
                                variant="light"
                                @click="loadSerie(data.item)"
                                class="mr-2 mt-2"
                            >
                                <i class="fa fa-pencil"></i>
                            </b-button>
                            <b-button
                                size="sm"
                                variant="light"
                                @click="modeSerie = 'remove'"
                                class="mr-2 mt-2"
                                v-if="modeSerie === 'insert'"
                            >
                                <i class="fa fa-trash"></i>
                            </b-button>
                            <b-button
                                size="sm"
                                variant="light"
                                @click="
                                    ;[
                                        removeSerie(data.item),
                                        (modeSerie = 'insert'),
                                    ]
                                "
                                class="mr-2 mt-2"
                                v-if="modeSerie === 'remove'"
                            >
                                <i class="fa fa-check"></i>
                            </b-button>
                            <b-button
                                size="sm"
                                variant="light"
                                @click="modeSerie = 'insert'"
                                class="mr-2 mt-2"
                                v-if="modeSerie === 'remove'"
                            >
                                <i class="fa fa-times"></i>
                            </b-button>
                            <span
                                class="mr-2 mt-2"
                                v-if="modeSerie === 'remove'"
                            >
                                Deseja Excluir o registro?
                            </span>
                        </template>
                    </b-table>
                </transition>
            </b-col>
            <b-col md="5" sm="12">
                <transition name="slide" type="animation" appear>
                    <b-table
                        class="table-responsive"
                        v-show="showTableNumber"
                        hover
                        key="slide"
                        head-variant="light"
                        :items="typedocumentssequencenumbers"
                        :fields="fieldsNumber"
                    >
                        <template slot="actions" slot-scope="data">
                            <b-button
                                v-b-modal.modalSequenceNumber
                                title="Editar registro"
                                size="sm"
                                variant="light"
                                @click="loadSequencialNumber(data.item)"
                                class="mr-2 mt-2"
                            >
                                <i class="fa fa-pencil"></i>
                            </b-button>
                            <b-button
                                size="sm"
                                variant="light"
                                @click="modeNumber = 'remove'"
                                class="mr-2 mt-2"
                                v-if="modeNumber === 'insert'"
                            >
                                <i class="fa fa-trash"></i>
                            </b-button>
                            <b-button
                                size="sm"
                                variant="light"
                                @click="
                                    ;[
                                        removeSequencialNumber(data.item),
                                        (modeNumber = 'insert'),
                                    ]
                                "
                                class="mr-2 mt-2"
                                v-if="modeNumber === 'remove'"
                            >
                                <i class="fa fa-check"></i>
                            </b-button>
                            <b-button
                                size="sm"
                                variant="light"
                                @click="modeNumber = 'insert'"
                                class="mr-2 mt-2"
                                v-if="modeNumber === 'remove'"
                            >
                                <i class="fa fa-times"></i>
                            </b-button>
                            <span
                                class="mr-2 mt-2"
                                v-if="modeNumber === 'remove'"
                            >
                                Deseja Excluir o registro?
                            </span>
                        </template>
                    </b-table>
                </transition>
            </b-col>
        </b-row>

        <b-modal
            id="modalSequenceNumber"
            ref="modal"
            size="lg"
            title-tag="h6"
            title="Número seguêncial de Documento"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveSequencialNumber()"
        >
            <b-form>
                <b-row>
                    <b-col md="5" sm="12">
                        <b-form-group
                            label="Empresa:"
                            label-for="typedocumentssequencenumber-company_id"
                        >
                            <b-form-select
                                id="typedocumentssequencenumber-company_id"
                                size="sm"
                                :options="companys"
                                v-model="typedocumentssequencenumber.company_id"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3" sm="12">
                        <b-form-group
                            label="Operação:"
                            label-for="typedocumentssequencenumber-operation_id"
                        >
                            <b-form-select
                                id="typedocumentssequencenumber-operation_id"
                                size="sm"
                                :options="operations"
                                v-model="
                                    typedocumentssequencenumber.operation_id
                                "
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="2" sm="12">
                        <b-form-group
                            label="Nº Inicial:"
                            label-for="typedocumentssequencenumber-sequence_number_start"
                        >
                            <b-form-input
                                id="typedocumentssequencenumber-sequence_number_start"
                                v-model="
                                    typedocumentssequencenumber.sequence_number_start
                                "
                                type="number"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="2" sm="12">
                        <b-form-group
                            label="Nº Final:"
                            label-for="typedocumentssequencenumber-sequence_number_end"
                        >
                            <b-form-input
                                id="typedocumentssequencenumber-sequence_number_end"
                                v-model="
                                    typedocumentssequencenumber.sequence_number_end
                                "
                                type="number"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3" sm="12">
                        <div class="form-group">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    v-model="
                                        typedocumentssequencenumber.blocked
                                    "
                                    true-value="1"
                                    false-value="0"
                                    type="checkbox"
                                    id="typedocumentssequencenumber-blocked"
                                    :readonly="
                                        mode === 'remove' ||
                                            mode === 'read' ||
                                            mode === 'insert'
                                    "
                                />
                                <label
                                    class="form-check-label"
                                    for="typedocumentssequencenumber-blocked"
                                >
                                    Bloqueado?
                                </label>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
        <b-modal
            id="modalSerie"
            ref="modal"
            size="sm"
            title-tag="h6"
            title="Série"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveSerie()"
        >
            <b-form>
                <b-row>
                    <b-col md="5" sm="12">
                        <b-form-group label="Série:" label-for="serie-serie">
                            <b-form-input
                                id="serie-serie"
                                type="text"
                                v-model="serie.serie"
                                size="sm"
                                placeholder="Série..."
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="6" sm="12">
                        <div class="form-group">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    v-model="serie.tax_required"
                                    true-value="1"
                                    false-value="0"
                                    type="checkbox"
                                    id="serie-tax_required"
                                />
                                <label
                                    class="form-check-label"
                                    for="serie-tax_required"
                                    >Imposto Requirido?</label
                                >
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'
var moment = require('moment-timezone')

export default {
    name: 'TypeDocument',
    components: { PageTitle },
    data: function() {
        return {
            mode: 'insert',
            modeNumber: 'insert',
            modeSerie: 'insert',
            search: '',
            typedocument: {},
            typedocumentssequencenumber: {},
            serie: {},
            series: [],
            typedocuments: [],
            typedocumentssequencenumbers: [],
            taxdocuments: [],
            operations: [],
            companys: [],
            showTable: false,
            showTableNumber: false,
            showTableSerie: false,
            isBusy: false,
            perPage: 5,
            currentPage: 1,
            headerBgVariant: 'dark',
            headerTextVariant: 'light',
            bodyBgVariant: 'light',
            bodyTextVariant: 'dark',
            footerBgVariant: 'warning',
            footerTextVariant: 'dark',
            fields: [
                { key: 'name_type_document', label: 'Nome', sortable: true },
                {
                    key: 'name_reduced',
                    label: 'Reduzido',
                    sortable: false,
                    variant: 'secondary',
                },
                {
                    key: 'tax_document_id',
                    label: 'Modelo',
                    sortable: false,
                    variant: 'primary',
                },
                { key: 'actions', label: 'Ações', variant: 'light' },
            ],
            fieldsNumber: [
                { key: 'name_company', label: 'Empresa', sortable: true },
                {
                    key: 'name_operation',
                    label: 'Operação',
                    sortable: false,
                    variant: 'secondary',
                },
                {
                    key: 'sequence_number_start',
                    label: 'Nº Inicial',
                    sortable: true,
                },
                {
                    key: 'sequence_number_end',
                    label: 'Nº Final',
                    sortable: true,
                },
                {
                    key: 'blocked',
                    label: 'Bloqueado',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não'),
                },
                { key: 'actions', label: 'Ações', variant: 'light' },
            ],
            fieldsSerie: [
                { key: 'serie', label: 'Série', sortable: true },
                {
                    key: 'tax_required',
                    label: 'Imposto Obrig.',
                    sortable: false,
                    formatter: value => (value ? 'Sim' : 'Não'),
                },
                { key: 'actions', label: 'Ações', variant: 'light' },
            ],
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        filteredList() {
            return this.typedocuments.filter(typedocument => {
                return typedocument.name_type_document
                    .toLowerCase()
                    .includes(this.search.toLowerCase())
            })
        },
        icon() {
            return this.showTable ? 'fa-retweet' : 'fa-search'
        },
        rows() {
            return this.typedocuments.length
        },
    },
    methods: {
        async loadTypeDocuments() {
            const url = `${baseApiUrl}/typedocuments`
            await axios.get(url).then(res => {
                this.typedocuments = res.data
                this.isBusy = false
            })
        },
        toggleBusy() {
            this.isBusy = !this.isBusy
        },
        async loadSequencialNumbers() {
            const url = `${baseApiUrl}/typedocumentssequencenumbers/${this.typedocument.id}/typedocuments`
            await axios.get(url).then(res => {
                this.typedocumentssequencenumbers = res.data
            })
        },
        async loadSeries() {
            const url = `${baseApiUrl}/series/${this.typedocument.id}/typedocuments`
            await axios.get(url).then(res => {
                this.series = res.data
            })
        },
        async reset() {
            this.mode = 'insert'
            await this.loadTypeDocuments()
        },
        alterModo() {
            this.mode = 'save'
            this.$refs.searchFocus.focus()
            this.typedocument = {}
        },
        async save() {
            const method = this.typedocument.id ? 'put' : 'post'
            const id = this.typedocument.id ? `/${this.typedocument.id}` : ''
            await axios[method](
                `${baseApiUrl}/typedocuments${id}`,
                this.typedocument
            )
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.reset()
                })
                .catch(showError)
        },
        async remove() {
            const id = this.typedocument.id
            await axios
                .delete(`${baseApiUrl}/typedocuments/${id}`)
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.reset()
                })
                .catch(showError)
        },
        loadTypeDocument(typedocument, mode = 'save') {
            this.$refs.searchFocus.focus()
            this.mode = mode
            this.typedocument = { ...typedocument }
        },
        async loadTaxDocuments() {
            const url = `${baseApiUrl}/taxdocuments`
            await axios.get(url).then(res => {
                this.taxdocuments = res.data.map(taxdocument => {
                    return {
                        value: taxdocument.id,
                        text: taxdocument.tax_document_name,
                    }
                })
            })
        },
        async loadCompanys() {
            const url = `${baseApiUrl}/companys`
            await axios.get(url).then(res => {
                this.companys = res.data.map(company => {
                    return { value: company.id, text: company.name_company }
                })
            })
        },
        async loadOperation() {
            const url = `${baseApiUrl}/operations`
            await axios.get(url).then(res => {
                this.operations = res.data.map(operation => {
                    return {
                        value: operation.id,
                        text: operation.name_operation,
                    }
                })
            })
        },
        async removeSequencialNumber(sequencia) {
            const id = sequencia.id
            await axios
                .delete(`${baseApiUrl}/typedocumentssequencenumbers/${id}`)
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadSequencialNumbers()
                })
                .catch(showError)
        },
        async removeSerie(serie) {
            const id = serie.id
            await axios
                .delete(`${baseApiUrl}/series/${id}`)
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadSeries()
                })
                .catch(showError)
        },
        async actionNewSequenceNumber(typedocument) {
            this.typedocument = { ...typedocument }
            this.typedocumentssequencenumber = {}
            await this.loadSequencialNumbers()
            this.showTableNumber = true
        },
        async actionNewSerie(typedocument) {
            this.typedocument = { ...typedocument }
            this.serie = {}
            await this.loadSeries()
            this.showTableSerie = true
        },
        async saveSequencialNumber() {
            if (this.typedocumentssequencenumber.id) {
                this.typedocumentssequencenumber.user_update_id = this.user.id
                this.typedocumentssequencenumber.update_date = this.formatDate(
                    moment.utc().local()
                )
            } else {
                this.typedocumentssequencenumber.user_id = this.user.id
            }

            const method = this.typedocumentssequencenumber.id ? 'put' : 'post'
            const id = this.typedocumentssequencenumber.id
                ? `/${this.typedocumentssequencenumber.id}`
                : ''

            this.typedocumentssequencenumber.type_document_id = this.typedocument.id
            await axios[method](
                `${baseApiUrl}/typedocumentssequencenumbers${id}`,
                this.typedocumentssequencenumber
            )
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadSequencialNumbers()
                })
                .catch(showError)
        },
        async saveSerie() {
            this.serie.user_id = this.user.id
            const method = this.serie.id ? 'put' : 'post'
            const id = this.serie.id ? `/${this.serie.id}` : ''

            this.serie.type_document_id = this.typedocument.id
            await axios[method](`${baseApiUrl}/series${id}`, this.serie)
                .then(async () => {
                    this.$toasted.global.defaultSuccess()
                    await this.loadSeries()
                })
                .catch(showError)
        },
        loadSequencialNumber(typedocumentssequencenumber) {
            this.typedocumentssequencenumber = {
                ...typedocumentssequencenumber,
            }
        },
        loadSerie(serie) {
            this.serie = { ...serie }
        },
        focusAdd() {
            this.$refs.focusadd.focus()
        },
        focusSearch() {
            this.$refs.inputsearch.focus()
        },
    },
    async mounted() {
        await this.loadTypeDocuments()
        await this.loadTaxDocuments()
        await this.loadCompanys()
        await this.loadOperation()
        this.showTable = true
    },
}
</script>

<style>
.typedocument {
    font-size: 0.7rem;
}
.typedocument input,
label,
form {
    font-size: 0.7rem;
}
.typedocument button {
    font-size: 0.7rem;
}
.typedocument select {
    font-size: 0.7rem;
}
.typedocument table {
    font-size: 0.7rem;
}
#modalSequenceNumber {
    font-size: 0.7rem;
}
#modalSequenceNumber input,
label,
form {
    font-size: 0.7rem;
}
#modalSequenceNumber button {
    font-size: 0.7rem;
}
#modalSequenceNumber select {
    font-size: 0.7rem;
}

#modalSerie {
    font-size: 0.7rem;
}

#modalSerie button {
    font-size: 0.7rem;
}
#modalSerie input {
    font-size: 0.7rem;
}

@keyframes slide-in {
    from {
        transform: translateY(40px);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes slide-out {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(40px);
    }
}

.slide-enter-active {
    animation: slide-in 1s ease;
    transition: opacity 1s;
}

.slide-leave-active {
    animation: slide-out 1s ease;
    transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
    opacity: 0;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s;
}
</style>
